import { useEffect, useState } from 'react'

import { getGlobalFiltersSettings } from 'api/AccountActivityAPI'
import { GlobalFilterSetting } from 'api/AccountActivityAPI/types'

import { GlobalFilterSettingType } from './useAdvancedPreferences'

export const useGlobalFilters = () => {
  const [enabledGlobalFilters, setEnabledGlobalFilters] = useState<GlobalFilterSetting[]>([])

  useEffect(() => {
    getGlobalFiltersSettings().then(response => {
      const enabledFilters = response.data.filter((setting: GlobalFilterSetting) => {
        if (setting.name === GlobalFilterSettingType.IN_CRM) {
          // the in CRM filter setting is weird - when it is DISABLED, we effectively have the
          // filter "In CRM is true" ENABLED. hence the special case here.
          return !setting.isEnabled
        }
        return setting.isEnabled
      })
      setEnabledGlobalFilters(enabledFilters)
    })
  }, [])

  return enabledGlobalFilters
}
